import BillLading from '@/components/BillLading/BillLading';
import pdf from 'vue-pdf'
// import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import jwt_decode from 'jwt-decode'
export default {
    name: "sendBillDetail",
    conditionData: '',
    components: {
        BillLading,
        pdf
    },
    data() {
        return {
            showBillLading: true,
            showPdf: false,
            pdfSrc: '',
            numPages: 0,
            progress: 0,
            progressShow: true,
            // 提单预览中使用的签章图片路径
            sealImagePath: '',
            sealImagePathMap: {},
            sealImageNameMap: {},
            selectedSealImageName: '',
            signatureButtonDisabled: false,
            switchSignatureButtonDisabled: false,
            // 提单数据
            data: '',
            billLadingData: {
                shipper: 'shipper',
                billNo: 'billNo',
                consignee: 'consignee',
                notifyAddress: 'notifyAddressfasdfasdfas  fsdfasdfasdfasdfa sfasdf adfasdfasdf afasdfasdfasdfasd  fsdfasdfasdfa asdfasdf afasdfas dsfasdf asdfasdfasfa',
                placeOfreceipt: 'placeOfreceipt',
                firstVessel: 'firstVessel',
                portOfLoading: 'portOfLoading',
                secondVessel: 'secondVessel',
                portOfDischarge: 'portOfDischarge',
                placeOfDelivery: 'placeOfDelivery',
                freightPayableAt: 'freightPayableAt',
                NoOfOriginal: 'NoOfOriginal',
                declared: 'declared',
                totalNumber: 'freight',
                freight: 'freight',
                planceAndDate: 'planceAndDate',
                forRelease: 'forRelease',
                asAgent: 'asAgent',
                goodList: [],
                isAddtionalImageDisplay: ''
            }
        }
    },
    mounted: function () {

    },
    created() {
        this.init();
    },
    methods: {
        init() {
            // 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
            this.conditionData = this.$routerUtil.getParam();
            // this.billLadingData.shipper = this.conditionData.row.table_blCode;
            this.data = this.conditionData.row;
            this.data.goodList = this.data.billGoods;
            this.data.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
            this.getSealImagePath();
            // if (this.data.billSignatureFile) {
            //     this.data.billSignatureFile.forEach(file => {
            //         if (file.type === 1 && file.isSignature === 0) {
            //             this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
            //         }
            //     });
            // }
            // this.pdfSrc.onProgress = progress => {
            //     let tempProgress = progress.loaded / progress.total * 100;
            //     if(tempProgress > 100){
            //         tempProgress = 100;
            //     }
            //     this.progress = tempProgress;
            //     if (this.progress === 100) {
            //         setTimeout(() => {
            //             this.progressShow = false;
            //             for(const key in require.cache) {
            //                 if(require && require.cache && require.cache[key] && require.cache[key].exports && require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
            //                     console.log(key);
            //                     delete require.cache[key];
            //                 }
            //             }
            //         }, 500);
            //     }
            // };
            // this.loadPdfHandler();
        },
        doSignature() {
            // this.$routerUtil.setParam(this.conditionData.searchForm);
            // this.$router.push('BillSealManage');
            if (!this.sealImagePath) {
                this.$message({
                    message: this.$t('s_billSeal.signatureError'),
                    type: 'warning',
                    center: true
                });
                return;
            }

            this.loading = this.$loading({
                lock: true,
                text: this.$t('common.message.signing'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const param = {};
            param.id = this.data.id;
            param.version = this.data.version;
            // 获取当前用户公司
            const token = jwt_decode(sessionStorage.getItem('token'));
            const customerCompanyId = jwt_decode(sessionStorage.getItem('token')).customerCompanyId;
            // 如果是出单公司
            if (customerCompanyId === this.data.sendCompanyId) {
                param.scSignatureConfirmResult = 1;
                param.scSignatureConfirmUserAccount = token.userAccount;
                param.scSignatureConfirmUserName = token.userName;
                param.scSignatureConfirmDay = this.getNowFormatDate();
            }
            // 如果是收单公司
            if (customerCompanyId === this.data.receiveCompanyId) {
                param.rcSignatureConfirmResult = 1;
                param.rcSignatureConfirmUserAccount = token.userAccount;
                param.rcSignatureConfirmUserName = token.userName;
                param.rcSignatureConfirmDay = this.getNowFormatDate();
            }
            param.stampName = this.selectedSealImageName;
            console.log(param);
            this.$axios.get('/api/Signatures/signature', { params: param }).then(response => {
                let type = 'error';
                if (response.data.status === '1') {
                    type = 'success';
                    this.doCancel();
                }
                this.loading.close();
                this.$message({
                    message: this.$t(response.data.message),
                    type: type,
                    center: true
                });

            }).catch(e => {
                console.log(e);
                this.loading.close();
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        switchSignature() {
            if (this.selectedSealImageName.toLowerCase().indexOf('carrier') !== -1) {
                this.sealImagePath = "/api" + this.sealImagePathMap.agent;
                this.selectedSealImageName = this.sealImageNameMap.agent;
                return;
            }
            if (this.selectedSealImageName.toLowerCase().indexOf('agent') !== -1) {
                this.sealImagePath = "/api" + this.sealImagePathMap.carrier;
                this.selectedSealImageName = this.sealImageNameMap.carrier;
                return;
            }
        },
        doCancel() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.push('BillSealManage');
        },
        loadPdfHandler() {
            this.pdfSrc.promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        getNowFormatDate() {
            const date = new Date();
            const seperator1 = "-";
            const seperator2 = ":";
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            return date.getFullYear() + seperator1 + month + seperator1 + strDate
                + " " + date.getHours() + seperator2 + date.getMinutes()
                + seperator2 + date.getSeconds();
        },
        getSealImagePath() {
            this.$axios.get('/api/customerinfo/selectcustomerbyparam').then(res => {
                let images = res.data.resultData[0].seals;
                let hasCarrier = false;
                let hasAgent = false;
                for (let i = 0; i < images.length; i++) {
                    // 查找有效的公司印章
                    if (images[i].isenable == 1 && images[i].sealType == 0) {
                        // this.sealImagePath = "/api"+images[i].dealFile;
                        if (images[i].name.toLowerCase().indexOf('carrier') !== -1) {
                            this.sealImagePathMap['carrier'] = images[i].dealFile;
                            this.sealImageNameMap['carrier'] = images[i].name;
                            hasCarrier = true;
                        }
                        if (images[i].name.toLowerCase().indexOf('agent') !== -1) {
                            this.sealImagePathMap['agent'] = images[i].dealFile;
                            this.sealImageNameMap['agent'] = images[i].name;
                            hasAgent = true;
                        }
                    }
                }
                // 如果没有启用的印章
                if (hasAgent == false && hasCarrier == false) {
                    this.signatureButtonDisabled = true;
                    this.switchSignatureButtonDisabled = true;
                    this.$message({
                        message: this.$t('EM-351'),
                        type: 'error',
                        center: true
                    });
                    return;
                } else if (hasCarrier == false || hasAgent == false) {
                    this.switchSignatureButtonDisabled = true;
                }
                /*
              * 如果提单台头为wiffa：若签章方为wiffa，则加盖asCarrier章，签章方非wiffa，则加盖asAgent章
              *如果提单台头非wiffa：若签章方=出单方，则加盖asCarrier章，签章方≠出单方，则加盖asAgent章
              *
              * */
                //如果提单使用wiffa的logo
                if (this.data.billImageName === 'bill_image_wiffa.png') {
                    //当前签章公司是wiffa的场景下
                    if (this.data.signatureCompanyId === 1) {
                        // 如果存在carrier签章，则优先使用carrier签章
                        if (hasCarrier) {
                            this.sealImagePath = "/api" + this.sealImagePathMap['carrier'];
                            this.selectedSealImageName = this.sealImageNameMap['carrier'];
                        } else {
                            // 如果wiffa没有carrier签章则采用agent签章
                            this.sealImagePath = "/api" + this.sealImagePathMap['agent'];
                            this.selectedSealImageName = this.sealImageNameMap['agent'];
                        }

                    } else {
                        if (hasAgent) {
                            this.sealImagePath = "/api" + this.sealImagePathMap['agent'];
                            this.selectedSealImageName = this.sealImageNameMap['agent'];
                        } else {
                            this.sealImagePath = "/api" + this.sealImagePathMap['carrier'];
                            this.selectedSealImageName = this.sealImageNameMap['carrier'];
                        }
                    }
                } else {
                    if (this.data.sendCompanyId === this.data.signatureCompanyId) {
                        if (hasCarrier) {
                            this.sealImagePath = "/api" + this.sealImagePathMap['carrier'];
                            this.selectedSealImageName = this.sealImageNameMap['carrier'];
                        } else {
                            this.sealImagePath = "/api" + this.sealImagePathMap['agent'];
                            this.selectedSealImageName = this.sealImageNameMap['agent'];
                        }

                    } else {
                        if (hasAgent) {
                            this.sealImagePath = "/api" + this.sealImagePathMap['agent'];
                            this.selectedSealImageName = this.sealImageNameMap['agent'];
                        } else {
                            this.sealImagePath = "/api" + this.sealImagePathMap['carrier'];
                            this.selectedSealImageName = this.sealImageNameMap['carrier'];
                        }
                    }
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            })
        }
    }
}
